import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import { ArrowLeft, Loader2, FileText } from 'lucide-react';
import { API_URL } from '../../lib/api';

const PolicyPage = () => {
  const { slug } = useParams();
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/policies/${slug}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => setPolicy(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  // Simple markdown-like rendering (bold, newlines)
  const renderContent = (text) => {
    if (!text) return null;
    return text.split('\n').map((line, i) => {
      // Bold text
      const parts = line.split(/\*\*(.*?)\*\*/g);
      const rendered = parts.map((part, j) => 
        j % 2 === 1 ? <strong key={j}>{part}</strong> : part
      );
      return line.trim() === '' ? <br key={i} /> : <p key={i} className="mb-2">{rendered}</p>;
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Header />
      <main className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4">
          <Link to="/" className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 mb-8 group">
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
            Back to Home
          </Link>

          {loading ? (
            <div className="flex justify-center py-16">
              <Loader2 className="w-8 h-8 animate-spin text-emerald-500" />
            </div>
          ) : !policy ? (
            <div className="text-center py-16">
              <FileText className="w-16 h-16 text-slate-300 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-slate-800 mb-2">Policy Not Found</h1>
              <p className="text-slate-500">The requested policy page could not be found.</p>
            </div>
          ) : (
            <div className="bg-white rounded-2xl border border-slate-100 shadow-sm p-8 lg:p-12">
              <h1 className="text-3xl font-serif font-bold text-slate-800 mb-8">{policy.title}</h1>
              <div className="prose prose-slate max-w-none text-slate-600 leading-relaxed">
                {renderContent(policy.content)}
              </div>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PolicyPage;
